import { createGlobalStyle } from 'styled-components';
import { ThemeType } from './Constants';

export const theme = {
  colors: {
    primary: '#3D315B',
    secondary: '#444B6E',
    background: '#708B75',
    link: '#9AB87A',
    white: '#FFFFFF'
  },
  font: {
    size: {
      extraSmall: '14px',
      small: '16px',
      medium: '18px',
      large: '20px',
      extraLarge: '24px'
    }
  },
  breakpoint: {
    mobileS: '320px',
    mobileM: '640px',
    tablet: '768px',
    laptop: '1024px',
    laptopL: '1280px'
  }
};

export const GlobalStyle = createGlobalStyle<{ theme: ThemeType }>`
  *, ::before, ::after {
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: #e5e7eb;
  }

  body {
    margin: 0;
    font-size: 14px !important;
    color: #111111 !important;
    font-family: "Nunito Sans" !important;
  }

  .ui.checkbox label::after {
      background:  ${props => props.theme?.firstColor} !important;
      color: white !important;
  }  

  .trash {
    color: #db2828 !important;
  }

  .suicr-year-view-header {
    font-size: 13px !important;
  }

  .ui.selection.multiple.dropdown {
    .ui.label {
      background:  ${props => props.theme?.firstColor} !important;
      color: white;
    }
  }

  .rdw-link-modal-btn{
    color: white !important;
    background-color: ${props => props.theme?.firstColor} !important;
    }

  .ui.secondary.pointing.menu .item {
    text-transform: uppercase;
    font-size: 15px !important;
    border-width:6px
    font-weight: bold;
    background: color: #989898;
  }

  .ui.secondary.pointing.menu .active.item:after{
    color: black;
    content: ""; 
    display: flex;
    width: 33px;
    background: none !important;
    border-right: none !important;
    rotate: -45deg !important;
    border-bottom: 5px solid ${props => props.theme?.firstColor};
    margin-top: -15px;
  }

  th {
    background: ${props => props?.theme?.chEnv ? '#878787' : props?.theme?.firstColor} !important;
    color: white !important;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  input[type=number]{
    -moz-appearance: textfield !important;
  }

  .prompt.label {
    display: block !important;
    width: fit-content !important;
  }

  .ui.secondary.pointing.menu .item{
    border-bottom-style: none;    
    font-weight: bold;
    color: #989898;
  }

  .ui.menu{
    flex-direction: row;
    flex-wrap: wrap;
  }

  a {
    color: inherit;
    text-decoration: inherit;    
    font-size: 14px !important;
  }

  html {
    background-color: ${props => props.theme?.chEnv ? '#bc4353' : '#1e3a8a'};
  }

  html body {
    overflow-x: hidden;
    background: transparent;
    font-size: 1rem;
    line-height: 1.25rem;
    color: #1e293b;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: inherit;
    font-weight: inherit;
  }

  a {
    color: inherit;
    text-decoration: inherit;
    font-size: 14px;
  }

  b,
  strong {
    font-weight: bolder;
  }

  code,
  kbd,
  samp,
  pre {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 1em;
  }

  small {
    font-size: 80%;
  }

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }

  .ui.styled.accordion {
    .title {
    .icon {
    color: ${props => props.theme?.firstColor} !important;
      }
    }
  }
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: inherit;
    color: inherit;
    margin: 0;
    padding: 0;
  }

  button,
  select {
    text-transform: none;
  }
  
   button {
    background-color: ${props => props.theme?.firstColor} !important;
    :hover {
      background-color: ${props => props.theme?.secondColor} !important;
    }
  }
  .ui.positive.button {
    background-color: green !important;
  }

  .ui.negative.button {
    background-color: red !important;
  }

  :-moz-focusring {
    outline: auto;
  }

  :-moz-ui-invalid {
    box-shadow: none;
  }

  progress {
    vertical-align: baseline;
  }

  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    height: auto;
  }

  [type='search'] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }

  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }

  summary {
    display: list-item;
  }

  blockquote,
  dl,
  dd,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  hr,
  figure,
  p,
  pre {
    margin: 0;
  }

  fieldset {
    margin: 0;
    padding: 0;
  }

  legend {
    padding: 0;
  }

  p {    
    font-size: 14px !important;
  }

  div {
    font-size: 14px !important;
  }
  
  ol,
  menu {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  img, video {
    max-width: 100%;
    height: auto;
  }

  .ui.form .field>label {
    margin-bottom: .5rem;
    color: #5e6672;
    font-size: 1rem;
  }

  /*** Loader ***/
  .loader-custom {
    position: absolute;
    top: 50%;
    left: 50%;
    box-sizing: border-box;
    transform: translate(-50%, -50%);

    &:before {
     content: "";
     position: absolute;
     left: 50%;
     width: 1.9rem;
     max-height: 25px;
     bottom: 5px;
     transform: translate(-50%, 0);
     background-image: linear-gradient(#f7f0d2, #f7f0d2);
     animation: animateBg 3s cubic-bezier(.2, .6, .8, .4) infinite;
    }

    .milk-can-color {
      fill: ${props => props.theme?.firstColor || 'rgb(28, 117, 26)'} ;
    }

    svg {
      width: 5rem;
      height: 5rem;
    }
    
    @keyframes animateBg {
      0% {
        height: 0;
      }
      100% {
        height: 100%;
      }
    }
  }

  .calendar.icon {
    opacity: 1 !important;
  }

  .calendar.icon::before {
    color: ${props => props.theme?.firstColor || 'rgb(28, 117, 26)'} !important;
    :hover {
      background-color: ${props => props.theme?.secondColor} !important;
    }
  }

  .ui.toggle.checkbox .box:before, .ui.toggle.checkbox label:before {
    width: 2.5rem;
  }

  .ui.pointing.secondary.menu{
    border-bottom:unset;
  }

  .ui.secondary.pointing.menu .active.item{
    border-color: transparent !important;
  } 

  .ui.form .required.field>label:after{
    margin:0 !important;
    color:red !important;
  }


  label,
  span {
    font-size: 14px !important;
  }
  
  i.icon:hover{
    opacity:.7;
  }

  .table-large-icons {
    font-size: 1.2em !important;
  }

  /* 
    Margins - Unit: rem
    ml-1 = 0.25
    ml-2 = 0.50
    ml-3 = 0.75
    ml-4 = 1.00
    ml-5 = 1.25
    ml-6 = 1.50
    ml-7 = 1.75
    ml-8 = 2.00
    ml-9 = 2.25
    ml-10 = 2.50
  */
  .ml-8 {
    margin-left: 2rem !important;
  }

  .mb-8 {
    margin-bottom: 2rem !important;
  }

  .recharts-default-legend{
    display:none;
  }

  /* 
    Font size - Unit: rem
    font-size-{n}-{['m', 'l]}
  */
  .font-size-1 {
    font-size: .5rem !important;
  }

  .font-size-2 {
    font-size: 1rem !important;
  }

  .font-size-2-m {
    font-size: 1.25rem !important;
  }

  .font-size-3 {
    font-size: 1.5rem !important;
  }

  input[type="password"]::-ms-reveal {
    display: none;
  }

  /* Increase Semantic UI border visibility for form controls */
  .ui.input > input,
  .ui.form input:not([type]),
  .ui.form input[type="text"],
  .ui.form input[type="email"],
  .ui.form input[type="password"],
  .ui.form input[type="number"],
  .ui.form input[type="tel"],
  .ui.form input[type="url"],
  .ui.form input[type="date"],
  .ui.form input[type="search"],
  .ui.form textarea,
  .ui.selection.dropdown,
  .ui.form .ui.selection.dropdown {
    border-color: rgba(34, 36, 38, .4) !important;
  }

  .ui.checkbox label::before {
    border-color: rgba(34, 36, 38, .4) !important;
  }

  /* Restore blue focus highlight */
  .ui.input > input:focus,
  .ui.form input:focus,
  .ui.form textarea:focus,
  .ui.selection.dropdown:focus,
  .ui.selection.active.dropdown,
  .ui.selection.active.dropdown .menu {
    border-color: #6299be !important;
  }

  .ui.checkbox input:focus ~ label::before {
    border-color: #6299be !important;
  }
`;
